"use strict";

function canUseStorage(type) {
  var storage;
  try {
    storage = window[type];
    var x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return e instanceof DOMException && (e.name === 'QuotaExceededError' || e.name === 'QUOTA_EXCEEDED_ERR' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED' || e.toString().indexOf('QUOTA_EXCEEDED_ERR') !== -1 || e.toString().indexOf('QuotaExceededError') !== -1) && storage && storage.length !== 0;
  }
}
var session = {
  overflow: {},
  get: function get(key) {
    // Overflow
    var valueFromOverflow = this.overflow[key];
    if (valueFromOverflow) {
      return valueFromOverflow;
    }
    if (!canUseStorage('sessionStorage')) {
      return null;
    }
    var valueFromSession = sessionStorage.getItem(key);
    if (valueFromSession) {
      try {
        // Try to parse the value and return
        return JSON.parse(valueFromSession);
      } catch (error) {
        // If value exists but it's not valid JSON, still return the original value
        return valueFromSession;
      }
    }
    return null;
  },
  set: function set(key, value) {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      this.overflow[key] = value;
    }
  },
  remove: function remove(key) {
    var _this$overflow;
    if ((_this$overflow = this.overflow) !== null && _this$overflow !== void 0 && _this$overflow[key]) {
      delete this.overflow[key];
    }
    if (canUseStorage('sessionStorage')) {
      sessionStorage.removeItem(key);
    }
  },
  key: function key(i) {
    var _sessionStorage, _sessionStorage2;
    if (!canUseStorage('sessionStorage')) {
      var _Object$keys;
      return (_Object$keys = Object.keys(this.overflow)) === null || _Object$keys === void 0 ? void 0 : _Object$keys[i];
    }
    var keyFromSessionStorage = (_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.key(i);
    var sessionStorageLength = ((_sessionStorage2 = sessionStorage) === null || _sessionStorage2 === void 0 ? void 0 : _sessionStorage2.length) || 0;
    if (i >= sessionStorageLength) {
      var _Object$keys2;
      var overflowIndex = i - sessionStorageLength;
      return (_Object$keys2 = Object.keys(this.overflow)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2[overflowIndex];
    }
    return keyFromSessionStorage;
  },
  length: function length() {
    var overflowLength = Object.keys(this.overflow).length;
    if (!canUseStorage('sessionStorage')) {
      return overflowLength;
    }
    return sessionStorage.length + overflowLength;
  },
  clear: function clear() {
    this.overflow = {};
    if (canUseStorage('sessionStorage')) {
      sessionStorage.clear();
    }
  }
};
var local = {
  overflow: {},
  get: function get(key) {
    // Overflow
    var valueFromOverflow = this.overflow[key];
    if (valueFromOverflow) {
      return valueFromOverflow;
    }
    if (!canUseStorage('localStorage')) {
      return null;
    }
    var valueFromLocal = localStorage.getItem(key);
    if (valueFromLocal) {
      try {
        // Try to parse the value and return
        return JSON.parse(valueFromLocal);
      } catch (error) {
        // If value exists but it's not valid JSON, still return the original value
        return valueFromLocal;
      }
    }
    return null;
  },
  set: function set(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      this.overflow[key] = value;
    }
  },
  remove: function remove(key) {
    var _this$overflow2;
    if ((_this$overflow2 = this.overflow) !== null && _this$overflow2 !== void 0 && _this$overflow2[key]) {
      delete this.overflow[key];
    }
    if (canUseStorage('localStorage')) {
      localStorage.removeItem(key);
    }
  },
  key: function key(i) {
    var _localStorage, _localStorage2;
    if (!canUseStorage('localStorage')) {
      var _Object$keys3;
      return (_Object$keys3 = Object.keys(this.overflow)) === null || _Object$keys3 === void 0 ? void 0 : _Object$keys3[i];
    }
    var keyFromLocalStorage = (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.key(i);
    var localStorageLength = ((_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.length) || 0;
    if (i >= localStorageLength) {
      var _Object$keys4;
      var overflowIndex = i - localStorageLength;
      return (_Object$keys4 = Object.keys(this.overflow)) === null || _Object$keys4 === void 0 ? void 0 : _Object$keys4[overflowIndex];
    }
    return keyFromLocalStorage;
  },
  length: function length() {
    var overflowLength = Object.keys(this.overflow).length;
    if (!canUseStorage('localStorage')) {
      return overflowLength;
    }
    return localStorage.length + overflowLength;
  },
  clear: function clear() {
    this.overflow = {};
    if (canUseStorage('localStorage')) {
      localStorage.clear();
    }
  }
};
var store = {
  local: local,
  session: session,
  canUseStorage: canUseStorage
};
module.exports = store;